import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { USERS_COLLECTION } from "../UserProfile/StudentProfile/StudentDashboard";

export const useUserProfile = (uid) => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!uid) return;
    const unsub = onSnapshot(
      doc(db, USERS_COLLECTION, uid),
      (snap) => {
        setProfile(snap.exists() ? { uid: snap.id, ...snap.data() } : null);
        setLoading(false);
      }
    );
    return () => unsub();
  }, [uid]);

  return { profile, loading };
};
